module.exports = __webpack_public_path__ + "static/media/S_K.92863b24.png";